import { useQuery } from '@tanstack/react-query';
import { fetchSiteEquipmentAssets } from '@apis/equipment';

/**
 * Read the equipment registry for a site
 *   - `enabled: !!siteId` so the query doesn't fire on the `/equipment`
 *     (no-site-selected) redirect path.
 *   - `staleTime: 30_000` — equipment positions update live in trusstor,
 *     but the registry list itself rarely changes within a minute. The
 *     30-second window prevents redundant fetches on rapid navigation.
 *   - `refetchOnWindowFocus: true` so returning to the tab refreshes status
 *     even after the stale window has passed.
 */
export function useSiteEquipment(siteId: string | null) {
  return useQuery({
    queryKey: ['equipment', 'assets', siteId],
    queryFn: ({ signal }) => fetchSiteEquipmentAssets(siteId!, signal),
    enabled: !!siteId,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
  });
}
